import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from "chart.js";
import "chartjs-adapter-date-fns";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

const generateDateLabels = (days) => {
  const labels = [];
  const dates = [];
  const today = new Date();
  for (let i = days; i >= 0; i--) {
    const date = new Date(today);

    date.setDate(today.getDate() - i);
    labels.push(date.toISOString().split("T")[0]);
    dates.push(date);
  }

  return { labels, dates };
};

const countWebinarPurchases99ByDate = (webinarPurchases, dates) => {
  return dates.map((date) => {
    const startOfDay = new Date(date);
    startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);

    const count = webinarPurchases.filter((webPur) => {
      const createdAt = new Date(webPur.purchaseDay);
      return (
        createdAt >= startOfDay && createdAt <= endOfDay && webPur.amount == 99
      );
    }).length;

    return count;
  });
};

const countWebinarPurchasesAllByDate = (webinarPurchases, dates) => {
  return dates.map((date) => {
    const startOfDay = new Date(date);
    startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);

    const count = webinarPurchases.filter((webPur) => {
      const updatedAt = new Date(webPur.purchaseDay);
      return updatedAt > startOfDay && updatedAt <= endOfDay;
    }).length;
    return count;
  });
};
const countWebinarPurchases299ByDate = (webinarPurchases, dates) => {
  return dates.map((date) => {
    const startOfDay = new Date(date);
    startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);

    const count = webinarPurchases.filter((webPur) => {
      const updatedAt = new Date(webPur.purchaseDay);
      return (
        updatedAt > startOfDay && updatedAt <= endOfDay && webPur.amount == 299
      );
    }).length;
    return count;
  });
};

const WebinarPayChart = ({ webinarPurchases, webinarFrom = 30 }) => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    const { labels, dates } = generateDateLabels(webinarFrom);
    const webinarPurchasesCountAll = countWebinarPurchasesAllByDate(
      webinarPurchases,
      dates
    );
    const webinarPurchasesCount299 = countWebinarPurchases299ByDate(
      webinarPurchases,
      dates
    );
    const webinarPurchasesCount99 = countWebinarPurchases99ByDate(
      webinarPurchases,
      dates
    );

    const data = {
      labels: labels,
      datasets: [
        {
          label: "Webinar Purchases (All)",
          data: webinarPurchasesCountAll,
          backgroundColor: "rgba(153, 102, 255, 0.5)",
          borderColor: "rgba(153, 102, 255, 1)",
          borderWidth: 1,
          tension: 0.5,
          hidden: true,
        },

        {
          label: "Webinar Purchases (299.00)",
          data: webinarPurchasesCount299,
          backgroundColor: "rgba(75, 192, 192, 0.5)",
          borderColor: "rgba(75, 192, 192, 1)",
          borderWidth: 1,
          tension: 0.5,
        },
        {
          label: "Webinar Purchases (99.00)",
          data: webinarPurchasesCount99,
          backgroundColor: "rgba(54, 162, 235, 0.5)",
          borderColor: "rgba(54, 162, 235, 1)",
          borderWidth: 1,
          tension: 0.5,
        },
      ],
    };

    setChartData(data);
  }, [webinarPurchases, webinarFrom]);

  const options = {
    plugins: {
      tooltip: {
        theme: "dark",
      },
      legend: {
        display: true,
      },
    },
    responsive: true,
    layout: {
      padding: {
        top: 10,
        left: 10,
        right: 10,
        bottom: 10,
      },
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: "day",
        },
        stacked: true,
        grid: {
          display: true,
          color: "rgba(200, 200, 200, 0.6)",
          borderColor: "rgba(200, 200, 200, 0.6)",
        },
        ticks: {
          padding: 10,
          color: "#000",
        },
        title: {
          display: false,
        },
      },
      y: {
        grid: {
          display: true,
          color: "rgba(200, 200, 200, 0.6)",
          borderColor: "rgba(200, 200, 200, 0.6)",
        },
        ticks: {
          padding: 10,
          color: "#000",
        },
      },
    },
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    borderColor: "rgba(0, 0, 0, 0.1)",
    borderWidth: 1,
    animation: {
      duration: 2000,
      easing: "easeOutQuart",
      loop: false,
    },
  };

  return <Line data={chartData} options={options} />;
};

export default WebinarPayChart;
